import React from 'react';

import {
    Box,
    Typography,
} from '@material-ui/core';

import {
    makeStyles,
    useTheme,
} from '@material-ui/core/styles';

import {
    merge as lodashMerge
} from 'lodash';





//
// Style propre au composant
//
// ATTENTION : ici, il est nécessaire de définir 'useStyle' comme une fonction retournant
// le résultat de 'makestyle' et non pas directement comme le résultat de 'makestyle'. En
// effet, la valeur retournée par 'makeStyles' doit être recalculée à chaque rendu, sinon
// les valeurs associées aux "media queries" semblent ne pas être mises à jour mais
// uniquement la partie 'common' (les 'media query' semblent ne pas être recalculées)
//
const useStyles = () => makeStyles((theme) => ({

    contentStaticRoot: style => ({
        ...style.contentStaticRoot.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentStaticRoot.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentStaticRoot.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentStaticRoot.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentStaticRoot.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentStaticRoot.xl,
        },
    }),

    contentStaticTitle: style => ({
        ...style.contentStaticTitle.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentStaticTitle.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentStaticTitle.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentStaticTitle.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentStaticTitle.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentStaticTitle.xl,
        },
    }),

    contentStaticContent: style => ({
        ...style.contentStaticContent.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentStaticContent.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentStaticContent.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentStaticContent.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentStaticContent.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentStaticContent.xl,
        },
    }),

}));



//
// Composant représentant un contenu statique, c'est-à-dire au format HTML
// Toutes les données à afficher sont contenues dans 'data'
//
export const ContentStatic = (props) => {


    const { title, params, style, data } = props;


    ////////////////////////////////////////
    //                                    //
    //          Gestion du style          //
    //                                    //
    ////////////////////////////////////////

    // On crée le style
    const theme = useTheme();

    // On fusionne les styles récupérés avec un template par défaut
    // pour être sûr que toutes les propriétés soient disponibles
    // Les valeurs contenues dans le style 'style' (fournies par le serveur)
    // écraseront les valeurs par défaut
    //
    // ATTENTION : ici, 'useStyles' est une fonction retournant le résultat de
    // 'makeStyles' (retournant également une fonction) d'où le double appel.
    // Cette étape supplémentaire est nécessaire pour les valeurs associées aux
    // "media query" soient correctement mises à jour
    //
    const classes = useStyles()(
        lodashMerge(
            {
                contentStaticRoot: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentStaticTitle: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentStaticContent: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
            },
            style
        )
    );



    //////////////////////////////////////////
    //                                      //
    //          Rendu du composant          //
    //                                      //
    //////////////////////////////////////////

    return (
        <Box
            className={classes.contentStaticRoot}
        >
            {title &&
                <Typography
                    className={classes.contentStaticTitle}
                    component="h1"
                    variant="h1"
                >
                    {title}
                </Typography>
            }

            <Box
                className={classes.contentStaticContent}
                dangerouslySetInnerHTML={{ __html: data.content }}
            />
        </Box>
    );
}
